"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var Styles = _interopRequireWildcard(require("./style"));
var _colors = require("../style/colors");
var _Icon = require("../Icon");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const Wrapper = /*#__PURE__*/_styledComponents.default.div.withConfig({
  displayName: "Avatar__Wrapper",
  componentId: "bufferapp-ui__sc-ka4tdj-0"
})(["", ""], props => Styles.wrapper[props.size]);
const Image = /*#__PURE__*/_styledComponents.default.div.withConfig({
  displayName: "Avatar__Image",
  componentId: "bufferapp-ui__sc-ka4tdj-1"
})(["", ""], props => Styles.image[props.type][props.size]);
const TwitterIcon = _ref => {
  let {
    size
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(Styles.SocialIconWrapper, {
    size: size,
    bgColor: _colors.twitter
  }, /*#__PURE__*/_react.default.createElement(_Icon.ChannelX, {
    size: "small",
    color: "white"
  }));
};
const socialIconMap = new Map([['instagram', _ref2 => {
  let {
    size
  } = _ref2;
  return /*#__PURE__*/_react.default.createElement(Styles.SocialIconWrapper, {
    size: size,
    bgColor: _colors.instagram
  }, /*#__PURE__*/_react.default.createElement(_Icon.Instagram, {
    size: "small",
    color: "white"
  }));
}], ['facebook', _ref3 => {
  let {
    size
  } = _ref3;
  return /*#__PURE__*/_react.default.createElement(Styles.SocialIconWrapper, {
    size: size,
    bgColor: _colors.facebook
  }, /*#__PURE__*/_react.default.createElement(_Icon.Facebook, {
    size: "small",
    color: "white"
  }));
}], ['twitter', TwitterIcon], ['x', TwitterIcon], ['linkedin', _ref4 => {
  let {
    size
  } = _ref4;
  return /*#__PURE__*/_react.default.createElement(Styles.SocialIconWrapper, {
    size: size,
    bgColor: _colors.linkedin
  }, /*#__PURE__*/_react.default.createElement(_Icon.LinkedIn, {
    size: "small",
    color: "white"
  }));
}], ['pinterest', _ref5 => {
  let {
    size
  } = _ref5;
  return /*#__PURE__*/_react.default.createElement(Styles.SocialIconWrapper, {
    size: size,
    bgColor: _colors.pinterest
  }, /*#__PURE__*/_react.default.createElement(_Icon.Pinterest, {
    size: "small",
    color: "white"
  }));
}], ['googlebusiness', _ref6 => {
  let {
    size
  } = _ref6;
  return /*#__PURE__*/_react.default.createElement(Styles.SocialIconWrapper, {
    size: size,
    bgColor: _colors.googlebusiness
  }, /*#__PURE__*/_react.default.createElement(_Icon.Gbp, {
    size: "small",
    color: "white"
  }));
}], ['shopify', _ref7 => {
  let {
    size
  } = _ref7;
  return /*#__PURE__*/_react.default.createElement(Styles.SocialIconWrapper, {
    size: size,
    bgColor: _colors.shopify
  }, /*#__PURE__*/_react.default.createElement(_Icon.Shopify, {
    size: "small",
    color: "white"
  }));
}], ['tiktok', _ref8 => {
  let {
    size
  } = _ref8;
  return /*#__PURE__*/_react.default.createElement(Styles.SocialIconWrapper, {
    size: size,
    bgColor: _colors.tiktok
  }, /*#__PURE__*/_react.default.createElement(_Icon.Tiktok, {
    size: "small",
    color: "white"
  }));
}], ['startPage', _ref9 => {
  let {
    size
  } = _ref9;
  return /*#__PURE__*/_react.default.createElement(Styles.SocialIconWrapper, {
    size: size,
    bgColor: _colors.startpage
  }, /*#__PURE__*/_react.default.createElement(Styles.StartPageIcon, null, /*#__PURE__*/_react.default.createElement(_Icon.StartPage, {
    size: "small",
    color: "white"
  }), ' '));
}], ['mastodon', _ref10 => {
  let {
    size
  } = _ref10;
  return /*#__PURE__*/_react.default.createElement(Styles.SocialIconWrapper, {
    size: size,
    bgColor: _colors.mastodon
  }, /*#__PURE__*/_react.default.createElement(_Icon.Mastodon, {
    size: "small",
    color: "white"
  }));
}], ['youtube', _ref11 => {
  let {
    size
  } = _ref11;
  return /*#__PURE__*/_react.default.createElement(Styles.SocialIconWrapper, {
    size: size,
    bgColor: _colors.youtube
  }, /*#__PURE__*/_react.default.createElement(_Icon.Youtube, {
    size: "small",
    color: "white"
  }));
}], ['threads', _ref12 => {
  let {
    size
  } = _ref12;
  return /*#__PURE__*/_react.default.createElement(Styles.SocialIconWrapper, {
    size: size,
    bgColor: _colors.threads
  }, /*#__PURE__*/_react.default.createElement(_Icon.Threads, {
    size: "small",
    color: "white"
  }));
}], ['bluesky', _ref13 => {
  let {
    size
  } = _ref13;
  return /*#__PURE__*/_react.default.createElement(Styles.SocialIconWrapper, {
    size: size,
    bgColor: _colors.bluesky
  }, /*#__PURE__*/_react.default.createElement(_Icon.Bluesky, {
    size: "small",
    color: "white"
  }));
}]]);
const Avatar = _ref14 => {
  let {
    src,
    alt,
    type,
    size,
    network,
    fallbackUrl
  } = _ref14;
  const SocialIcon = network && socialIconMap.get(network);
  return /*#__PURE__*/_react.default.createElement(Wrapper, {
    size: size
  }, SocialIcon && /*#__PURE__*/_react.default.createElement(SocialIcon, {
    size: size
  }), /*#__PURE__*/_react.default.createElement(Image, {
    size: size,
    type: type,
    src: src,
    fallbackUrl: fallbackUrl,
    alt: alt
  }));
};
Avatar.propTypes = {
  src: _propTypes.default.string.isRequired,
  alt: _propTypes.default.string.isRequired,
  fallbackUrl: _propTypes.default.string,
  type: _propTypes.default.oneOf(['default', 'social', 'status']),
  size: _propTypes.default.oneOf(['large', 'medium', 'small', 'xsmall']),
  network: _propTypes.default.oneOf(['facebook', 'twitter', 'instagram', 'linkedin', 'google', 'pinterest', 'shopify', 'tiktok', 'startPage', 'googlebusiness', 'mastodon', 'youtube', 'x', 'threads', 'bluesky'])
};
Avatar.defaultProps = {
  type: 'default',
  size: 'small',
  fallbackUrl: 'https://s3.amazonaws.com/buffer-ui/Default+Avatar.png',
  network: null
};
var _default = exports.default = Avatar;